/**
 * Env vars validadas no boot. Se faltar, explode com mensagem clara em dev.
 * Supabase é criado manualmente no dashboard pelo Marco (decisão de setup).
 */
const required = ['VITE_SUPABASE_URL', 'VITE_SUPABASE_ANON_KEY'] as const;

type RequiredEnv = (typeof required)[number];

function readEnv(): Record<RequiredEnv, string> {
  const result = {} as Record<RequiredEnv, string>;
  const missing: string[] = [];
  for (const key of required) {
    const value = import.meta.env[key];
    if (!value) missing.push(key);
    else result[key] = value;
  }
  if (missing.length > 0) {
    const message = `Missing env vars: ${missing.join(', ')}. Copie .env.example para .env.local e preencha.`;
    if (import.meta.env.DEV) {
      console.error(message);
    }
    throw new Error(message);
  }
  return result;
}

export const env = readEnv();
